import {
  NavigationState,
  navigationInitialState,
  navigationReducer,
} from './navigation.reducer';
import {
  SideBarState,
  sideBarInitialState,
  sideBarReducer,
} from './side-bar.reducer';
import {
  ContentState,
  contentInitialState,
  contentReducer,
} from './content.reducer';
import {
  ScreenState,
  screenInitialState,
  screenReducer
} from './screen.reducer';

export interface LayoutState {
  navigation: NavigationState;
  sideBar: SideBarState;
  content: ContentState;
  screen: ScreenState;
}

export const layoutInitialState: LayoutState = {
  navigation: navigationInitialState,
  sideBar: sideBarInitialState,
  content: contentInitialState,
  screen: screenInitialState,
};

export function layoutReducer(state = layoutInitialState, action: any) {
  const navigation = navigationReducer(state.navigation, action);
  if (state.navigation !== navigation) {
    state = { ...state, navigation };
  }

  const sideBar = sideBarReducer(state.sideBar, action);
  if (state.sideBar !== sideBar) {
    state = { ...state, sideBar };
  }

  const content = contentReducer(state.content, action);
  if (state.content !== content) {
    state = { ...state, content };
  }

  const screen = screenReducer(state.screen, action);
  if (state.screen !== screen) {
    state = { ...state, screen };
  }

  return state;
}
